export const useTrailerCoverages = () => {
  return [25000, 30000, 35000, 40000, 45000, 50000].sort((a, b) => a - b);
};
